import moment from 'moment';
import {toastr} from 'react-redux-toastr';
import {
  initialize,
  registerField,
  change,
  formValueSelector
} from 'redux-form';
import {
  navigateTo,
  getJsonAsync,
  postJsonAsync,
  putJsonAsync
} from 'shared/actions';
import {loadTournament} from '../actions';
import {retrieveTournaments} from '../tournamentList/actions';
import {
  displayCentersDropdownList,
  displayCenterSaveButton,
  displayThemes,
  displayTimeZones,
  setCanAssignTag,
  setCanDeleteTag,
  setCards,
  setCardSelection,
  setDataExportOptions,
  setExportSelection,
  setIsAddingTag,
  setIsNewTournament,
  setLocationCertificationNumber,
  setStripeAccounts,
  setStripeAccountSelection,
  setAvailableTags,
  setTagIndex,
  setTournamentLocations,
  setTournamentLocationSearchResults,
  setTournamentTags,
  toggleTournamentLocationEditing
} from './actionTypes';
import {
  validateDate,
  validateEmail
} from 'shared/validators';
import { setErrorList } from 'shared/error/actionTypes';
import { animateScroll } from 'react-scroll';

const endOfDayDateTimeFormat='YYYY-MM-DD 23:59:59.000000';

export const clearPreviousSessionVariables = () => (dispatch, getState) => {
  const stateInformation = getState();

  stateInformation.tournament.general.locations = [];
  stateInformation.tournament.base.tournamentInfo.id = null;
};

// -- Handlers --

export const handleCancel = () => dispatch => {
  dispatch(navigateTo('tournament'));
};

export const handleCenterChange = certificationNumber => (dispatch) => {
  dispatch(displayCenterSaveButton(certificationNumber ? true : false));

  if (certificationNumber) {
    dispatch(setLocationCertificationNumber(certificationNumber));
  }
};

export const handleLocationAddClick = () => (dispatch, getState) => {
  const locations = getState().tournament.general.locations;
  const emptyLocation = {
    id: null,
    name: '',
    address: '',
    city: '',
    state: '',
    zipCode: '',
    certificationNumber: '',
    phone: ''
  };

  if (!locations.some(m => { return m.editing; })) {
    locations.push(emptyLocation);
  }

  dispatch(setTournamentLocations(locations));
  dispatch(registerLocationFields());
  dispatch(populateLocationFields(emptyLocation));
  dispatch(toggleTournamentLocationEditing(null));
  dispatch(displayCenterSaveButton(false));
  dispatch(displayCentersDropdownList(false));
};

export const handleLocationCancelClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;

  getState().tournament.general.locationName = '';
  getState().tournament.general.locationSearchResults.length = 0;
  if (tournamentId) {
    dispatch(retrieveLocations(tournamentId));
  }
  else {
    let locations = getState().tournament.general.locations;

    locations = locations.filter(x => x.certificationNumber !== '');
    dispatch(retrieveLocationsByStateData(locations));
  }
};

export const handleLocationRemoveClick = certificationNumber => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;

  if (tournamentId) {
    dispatch(postJsonAsync(`setup/tournament/${tournamentId}/location/${certificationNumber}/remove`))
      .then(() => {
        dispatch(retrieveLocations(tournamentId));
      });
  }
  else {
    let locations = getState().tournament.general.locations;

    locations = locations.filter(x => x.certificationNumber !== certificationNumber);
    dispatch(retrieveLocationsByStateData(locations));
  }
  toastr.success('Removed!', 'Tournament Location Removed Successfully.');
};

export const handleLocationSaveClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const certificationNumber = getState().tournament.general.certificationNumber;
  const zLocationSearchResults = getState().tournament.general.locationSearchResults;
  const name = zLocationSearchResults.filter((item) => item.zCertificationNumber === certificationNumber).map((item) => item.zName)[0];
  const zipCode = zLocationSearchResults.filter((item) => item.zCertificationNumber === certificationNumber).map((item) => item.zZipCode)[0];
  const city = zLocationSearchResults.filter((item) => item.zCertificationNumber === certificationNumber).map((item) => item.zCity)[0];
  const state = zLocationSearchResults.filter((item) => item.zCertificationNumber === certificationNumber).map((item) => item.zState)[0];
  const phone = zLocationSearchResults.filter((item) => item.zCertificationNumber === certificationNumber).map((item) => item.zPhone)[0];
  let id = "";

  if (tournamentId) {
    id = tournamentId;
  }
  else if (certificationNumber) {
    id = certificationNumber;
  }
  const data = {
    certificationNumber: certificationNumber,
    tournamentId: tournamentId
  };
  const data2 = {
    certificationNumber: certificationNumber,
    tournamentId: tournamentId,
    city: city,
    state: state,
    name: name,
    zipCode: zipCode,
    phone: phone,
    id: id
  };

  let data3 = [];

  data3.push(data2);
  if (!tournamentId) {

    let locations = getState().tournament.general.locations;

    locations = locations.filter(x => x.certificationNumber !== '');
    locations.push(data2);
    dispatch(setTournamentLocations(locations));
    toastr.success('Saved!', 'Tournament Location Saved Successfully.');
    return;
  }

  const promise = postJsonAsync(`setup/tournament/${tournamentId}/location`, data);

  dispatch(promise)
    .then(() => {
      toastr.success('Saved!', 'Tournament Location Saved Successfully.');
      dispatch(retrieveLocations(tournamentId));
    });
};

export const handleLocationSearchClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
  const selector = formValueSelector('tournamentSetup');
  const name = selector(getState(), 'tournamentLocationName');
  const zipCode = selector(getState(), 'tournamentLocationZipCode');
  const certificationNumber = selector(getState(), 'tournamentLocationCertificationNumber');
  const data = {
    name: name,
    zipCode: zipCode,
    certificationNumber: certificationNumber,
    tournamentId: tournamentId
  };
  const promise = postJsonAsync(`setup/tournament/locationSearch`, data);

  dispatch(promise)
    .then(results => {
      dispatch(setTournamentLocationSearchResults(results.centers.map(({ certificationNumber, name, city, state, zipCode, phone, lanesAvailable }) => ({
        value: certificationNumber,
        label: `${name} (#${certificationNumber}), ${city}, ${state} ${zipCode}`,
        zZipCode: zipCode,
        zName: name,
        zCity: city,
        zState: state,
        zCertificationNumber: certificationNumber,
        zPhone: phone,
        zlanesAvailable: lanesAvailable
      }))));
      dispatch(displayCentersDropdownList(results.centers.length > 0 ? true : false));
    });
};

export const handleSave = data => (dispatch, getState) => new Promise((resolve) => {
  const locations = getState().tournament.general.locations;
  const tagIndex = getState().tournament.general.tagIndex;
  const tournamentTags = getState().tournament.general.tournamentTags;
  const groupName = getState().shared.auth.groupName;
  const isAllowed = getState().shared.auth.isAllowed;

  let certificationNumberList = [];

  Object.entries(locations).forEach(entry => {
    const [, value] = entry;
    if (value.certificationNumber) {
      certificationNumberList.push(value.certificationNumber);
    }
  });

  if ((!locations || locations.length == 0 || certificationNumberList.length == 0)       
      && (tagIndex === null && (!tournamentTags || tournamentTags.length == 0))
      && isAllowed && groupName) {
    dispatch(setErrorList(['Please provide location(s) for this tournament.', 'Please provide a tag for this tournament.']));   
    setTimeout(() => {
      let elements = document.querySelectorAll('#sharedErrorList');
      animateScroll.scrollTo(elements[0].parentNode.offsetTop);
    }, 800);
    resolve();
    return;
  }

  if (!locations || locations.length == 0 || certificationNumberList.length == 0) {
    dispatch(setErrorList(['Please provide location(s) for this tournament.']));
    setTimeout(() => {
      let elements = document.querySelectorAll('#sharedErrorList');
      animateScroll.scrollTo(elements[0].parentNode.offsetTop);
    }, 800);
    resolve();
    return;
  }

  if (tagIndex === null && (!tournamentTags || tournamentTags.length == 0) && isAllowed && groupName) {
    dispatch(setErrorList(['Please provide a tag for this tournament.']));
    setTimeout(() => {
      let elements = document.querySelectorAll('#sharedErrorList');
      animateScroll.scrollTo(elements[0].parentNode.offsetTop);
    }, 800);
    resolve();
    return;
  }

  // scrub times from datepicker values
  data.startDate = moment(data.startDate).format('YYYY-MM-DD');
  data.endDate = moment(data.endDate).format(endOfDayDateTimeFormat);
  data.registrationCloseDate = moment(data.registrationCloseDate).format(endOfDayDateTimeFormat);
  data.LocationCertificationNumberList = certificationNumberList;

  // default tournament phone (dirty solution, but having React/Redux challenges with refresh)
  if (!data.tournamentPhone || (data.tournamentPhone && data.tournamentPhone.trim().length == 0)) {
    data.tournamentPhone = "1-800-514-BOWL";
  }

  const promise = data.id
    ? putJsonAsync(`setup/tournament/${data.id}`, data)
    : postJsonAsync('setup/tournament', data);

  dispatch(promise)
    .then(() => {
      toastr.success('Saved!', 'Tournament saved Successfully.');
      resolve();
      if (!data.id) {
        dispatch(navigateTo('tournament'));
        dispatch(retrieveTournaments());
      } else {
        dispatch(initialize('tournamentSetup', data));
        dispatch(loadTournament(data.id));
      }
    })
    .catch(() => resolve());
});

export const handleTagAddClick = () => (dispatch) => {
  dispatch(registerField('tournamentSetup', 'tournamentTagName', 'Field'));
  dispatch(change('tournamentSetup', 'tournamentTagName', ''));
  dispatch(setIsAddingTag(true));
};

export const handleTagCancelClick = () => (dispatch) => {
  dispatch(setIsAddingTag(false));
};

export const handleTagChange = value => (dispatch, getState) => {
  const tags = getState().tournament.general.tags;
  const tagIndex = tags.findIndex(x => x.value === value).toString();
  const isNewTournament = getState().tournament.general.isNewTournament;

  dispatch(change('tournamentSetup', 'tournamentTagName', tags[tagIndex].label));
  dispatch(setCanAssignTag(value != null));
  dispatch(setCanDeleteTag(value != null && !isNewTournament));
  dispatch(setTagIndex(tagIndex));
};

export const handleTagNameChange = value => (dispatch) => {
  const filteredValue = value.replace(/[^a-zA-Z0-9\s]/g, '');
  dispatch(change('tournamentSetup', 'tournamentTagName', filteredValue));
};

export const handleTagRemoveClick = tagId => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;
 
  dispatch(postJsonAsync(`setup/tournament/${tournamentId}/tournamentTag/${tagId}/remove`)).then(() => {
    dispatch(retrieveTags(tournamentId));
  });
};

export const handleTagSaveClick = () => (dispatch, getState) => {
  const tournamentId = getState().tournament.base.tournamentInfo.id;

  if (tournamentId) {
    const selector = formValueSelector('tournamentSetup');
    const tournamentTagName = selector(getState(), 'tournamentTagName');
    const data = {
      tournamentId: tournamentId,
      value: tournamentTagName ? tournamentTagName : ''
    };

    if (data && data.value.length > 0) {
      dispatch(postJsonAsync(`setup/tournament/${tournamentId}/tournamentTag`, data)).then(() => {
        toastr.success('Saved!', 'Tournament tag saved successfully.');
        dispatch(retrieveTags(tournamentId));
        dispatch(setIsAddingTag(false));
        dispatch(setCanAssignTag(false));
        dispatch(setCanDeleteTag(false));
        dispatch(registerField('tournamentSetup', 'tournamentTagName', 'Field'));
        dispatch(change('tournamentSetup', 'tournamentTagName', ''));
      });
    }
  } else {
    const selector = formValueSelector('tournamentSetup');
    const tournamentTagName = selector(getState(), 'tournamentTagName');

    const newTag = {
      label: tournamentTagName,
      value: tournamentTagName,
      editing: false
    };

    let tags = getState().tournament.general.tags;
    tags.push(newTag);
    let tagIndex = tags.findIndex(x => x.value === newTag.value).toString();
    dispatch(setTagIndex(tagIndex));
    dispatch(setIsAddingTag(false));
  }
};

// -- Retrievers --

export const retrieveCards = () => (dispatch) => {
  dispatch(getJsonAsync(`setup/tournament/campaigns/cards`)).then(data => {
    dispatch(setCards(data.map(({value, id}) => ({
      label: value,
      value: id
    }))));
  });
};

export const retrieveDataExportOptions = () => (dispatch) => {
  dispatch(getJsonAsync(`export/tournament`)).then(data =>
    dispatch(
      setDataExportOptions(
        data.map(({ id, description }) => ({
          value: id,
          label: description
        }))
      )
    )
  );
};

export const retrieveLocations = tournamentId => dispatch => {
  if (tournamentId) {
    dispatch(getJsonAsync(`setup/tournament/${tournamentId}/locations`))
      .then(data => dispatch(setTournamentLocations(data)));
  }
  else {
    dispatch(setTournamentLocations());
  }
};

export const retrieveLocationsByStateData = locationsData => dispatch => {
  if (locationsData) {
    dispatch(setTournamentLocations(locationsData));
  }
  else {
    dispatch(setTournamentLocations());
  }
};

export const retrieveSelectedCard = cardId => dispatch => {
  dispatch(setCardSelection({value: cardId}));
  dispatch(change('tournamentSetup', 'cardSelection', cardId));
};

export const retrieveSelectedExportOption = exportId => dispatch => {
  dispatch(setExportSelection({value: exportId}));
  dispatch(change('tournamentSetup', 'exportSelection', exportId));
};

export const retrieveSelectedStripeAccount = stripeAccountId => dispatch => {
  dispatch(setStripeAccountSelection({value: stripeAccountId}));
  dispatch(change('tournamentSetup', 'stripeAccountSelection', stripeAccountId));
};

export const retrieveStripeAccounts = () => dispatch => {
  dispatch(getJsonAsync(`setup/tournament/stripeAccounts`)).then(data => {
    dispatch(setStripeAccounts(data.map(({stripeAccountName, stripeAccountId}) => ({
      value: stripeAccountId,
      label: stripeAccountName
    }))));
  });
};

export const retrieveTags = tournamentId => (dispatch) => {
  dispatch(setIsNewTournament(true));
  dispatch(setCanAssignTag(false));
  dispatch(setCanDeleteTag(false));

  dispatch(getJsonAsync(`setup/tournament/campaigns/tags`)).then(data => {    
    dispatch(setAvailableTags(data.map(({value, id}) => ({
      label: value,
      value: id
    }))));

    dispatch(change('tournamentSetup', 'tagId', null));
    dispatch(setTagIndex(null));
    dispatch(setTournamentTags(null));
  })
  .catch(error => {
    console.error('Error fetching setup/tournament/campaigns/tags:', error);
  });

  if (tournamentId !== undefined) {
    dispatch(setIsNewTournament(false));
    dispatch(setCanAssignTag(true));
    dispatch(setCanDeleteTag(true));
    
    dispatch(getJsonAsync(`setup/tournament/${tournamentId}/tournamentCampaigns/tags`)).then(tags => {
      dispatch(setTournamentTags(tags.map(({value, id}) => ({
        label: value,
        value: id
      }))));

      dispatch(change('tournamentSetup', 'tagId', null));
      dispatch(setTagIndex(null));
    });
  }
};

export const retrieveThemes = () => dispatch => {
  // just listing the themes here for now, eventually this should be an API call
  dispatch(displayThemes([
    { label: 'Blue', value: 'blue' },
    { label: 'Red', value: 'red' },
    { label: 'Orange', value: 'orange' }
  ]));
};

export const retrieveTimeZones = () => dispatch => {
  dispatch(getJsonAsync('timezones')).then(data => {
    dispatch(displayTimeZones(data.map(({id, value}) => ({
      value: id,
      label: value
    }))));
  });
};

// -- Initialization --

export const setupTournamentForm = () => (dispatch, getState) => {
  const data = getState().tournament.base.tournamentInfo;

  dispatch(initialize('tournamentSetup', {
    ...data,
    ...{
        endDate: moment.parseZone(data.endDate).format(endOfDayDateTimeFormat),
        startDate: moment.utc(data.startDate).format('YYYY-MM-DD'),
        registrationCloseDate: data.registrationCloseDate ? moment.parseZone(data.registrationCloseDate).format(endOfDayDateTimeFormat) : null
    }
  }));
};

// -- Validation --

export const validate = (data) => {
  const errors = {};
  const currentDate = moment().format('YYYY-MM-DD');

  data.startDate = moment(data.startDate).format('YYYY-MM-DD');
  data.endDate = moment(data.endDate).format(endOfDayDateTimeFormat);
  data.registrationCloseDate = moment(data.registrationCloseDate).format(endOfDayDateTimeFormat);

  if (!data.name) {
    errors.name = 'Please provide a name for this tournament.';
  }

  if (!data.startDate || !validateDate(data.startDate)) {
    errors.startDate = 'Please set the tournament Start Date';
  }

  if (!data.endDate || !validateDate(data.endDate)) {
    errors.endDate = 'Please set the tournament End Date.';
  }
  else if (data.endDate && data.endDate < currentDate) {
    errors.endDate = 'End Date cannot be in the past';
  }

  if (data.startDate && data.endDate && data.startDate > data.endDate) {
    errors.startDate = 'Start Date must be older than or equal to End Date';
    errors.endDate = 'End Date must be equal to or later than Start Date!';
  }

  if (!validateDate(data.registrationCloseDate)) {
    errors.registrationCloseDate = 'Please set the tournament registration Close Date.';
  }
  else if (data.endDate && data.registrationCloseDate && data.registrationCloseDate > data.endDate) {
    errors.registrationCloseDate = 'Registration Date cannot be after the End Date';
  }
  else if (data.registrationCloseDate && data.registrationCloseDate < currentDate) {
    errors.registrationCloseDate = 'Registration Date cannot be in the past';
  }

  if ((typeof data.defaultAverage !== 'number' && !data.defaultAverage) || (data.defaultAverage < 0 || data.defaultAverage > 300)) {
    errors.defaultAverage = 'A bowling average is required and must be between 0 and 300';
  }

  if (!data.timeZone) {
    errors.timeZone = 'Please set the tournament Time Zone.';
  }

  if (!data.bccEmail || !validateEmail(data.bccEmail)) {
    errors.bccEmail = 'Please provide a valid email.';
  }

  if (!data.exportId) {
    errors.exportId = 'Please select a tournament management system for this tournament.';
  }

  return errors;
};

// -- Local Methods --

const populateLocationFields = location => dispatch => {
  dispatch(change('tournamentSetup', 'tournamentLocationName', location.name));
  dispatch(change('tournamentSetup', 'tournamentLocationAddress', location.address));
  dispatch(change('tournamentSetup', 'tournamentLocationCity', location.city));
  dispatch(change('tournamentSetup', 'tournamentLocationState', location.state));
  dispatch(change('tournamentSetup', 'tournamentLocationZipCode', location.zipCode));
  dispatch(change('tournamentSetup', 'tournamentLocationCertificationNumber', location.certificationNumber));
  dispatch(change('tournamentSetup', 'tournamentLocationPhone', location.phone));
  dispatch(change('tournamentSetup', 'tournamentLocationSearchResults', null));
};

const registerLocationFields = () => (dispatch) => {
  dispatch(registerField('tournamentSetup', 'tournamentLocationName', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationAddress', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationCity', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationState', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationZipCode', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationCertificationNumber', 'Field'));
  dispatch(registerField('tournamentSetup', 'tournamentLocationPhone', 'Field'));
  setTimeout(() => {
    // focus field after animatation finished (~400ms) by directly accessing the dom
    document.querySelectorAll('[name=tournamentLocationName]')[0].focus();
  }, 400);
};



// WEBPACK FOOTER //
// ./src/features/tournament/general/actions.js